import React from "react";

const AddAbout = () => {
  return <div>AddAbout</div>;
};

export default AddAbout;
